(function () {
  /**
   * @ngdoc component
   * @name abxWorkOrderCardMobile
   *
   * @param {String} status - work order status
   * @param {String} entityType - room or asset
   * @param {Object} entity - room or asset object
   * @param {Function} fetch - Function used to fetch work orders
   * @description
   * A card displaying work orders for a room or asset.
   */
  angular
    .module("akitabox.mobile.components.workOrderCardMobile", [
      "akitabox.core.services.workOrder",
      "akitabox.core.toast",
      "ui.mask",
    ])
    .component("abxWorkOrderCardMobile", {
      bindings: {
        status: "@abxStatus",
        entityType: "@abxEntityType",
        entity: "<abxEntity",
        icon: "@abxIcon",
        displayDate: "@abxDisplayDate",
        fetch: "&",
      },
      controller: abxWorkOrderCardMobileController,
      controllerAs: "vm",
      templateUrl:
        "app/mobile/components/work-order-card/work-order-card.component.html",
    });

  /* @ngInject */
  function abxWorkOrderCardMobileController(
    $q,
    $state,
    WorkOrderService,
    ToastService
  ) {
    var self = this;
    var SHORT_DATE_FORMAT = "MMM d, yyyy";
    self.workOrderCount = 0;
    self.dateFormatShort = SHORT_DATE_FORMAT;

    self.limit = 5;
    self.fetching = false;
    self.moreToLoad = true;
    self.skip = 0;
    self.items = null;
    self.expanded = true;

    // Functions
    self.getWorkOrders = getWorkOrders;
    self.toggleCard = toggleCard;
    self.selectWorkOrder = selectWorkOrder;
    self.getDateDescription = getDateDescription;

    self.$onInit = function () {
      getWorkOrders();
      getWorkOrderCount();
    };

    // =================
    // Public Functions
    // =================

    function getWorkOrders() {
      if (self.fetching || !self.moreToLoad) return;
      self.fetching = true;
      $q.resolve(self.fetch({ skip: self.skip, status: self.status }))
        .then(function (items) {
          // Lazy initialize items
          if (!self.items) self.items = [];
          // Add items
          self.items = self.items.concat(items);
          // There's no more to load if we got less than our limit
          if ((items && items.length < self.limit) || !items) {
            self.moreToLoad = false;
          }
          // Update skip
          self.skip += self.limit;
        })
        .catch(function () {
          if (!self.items) self.items = [];
        })
        .finally(function () {
          self.fetching = false;
        });
    }

    function getWorkOrderCount() {
      var query;
      if (self.entityType === "asset") {
        query = { count: true, asset: self.entity._id, status: self.status };
      } else if (self.entityType === "room") {
        query = { count: true, room: self.entity._id, status: self.status };
      } else {
        ToastService.showError("Invalid entityType");
      }
      WorkOrderService.getByBuildingId(self.entity.building, query)
        .then(function (response) {
          self.workOrderCount = response.count;
          self.workOrderHeader = self.status + " (" + self.workOrderCount + ")";
        })
        .catch(ToastService.showError);
    }

    function toggleCard() {
      self.expanded = !self.expanded;
    }

    /**
     * Navigate to work order details
     *
     * @param {Object} workOrder    The selected work order
     */
    function selectWorkOrder(workOrder) {
      $state.go("app.building.workOrder.detail", {
        buildingId: workOrder.building,
        workOrderId: workOrder._id,
      });
    }

    /**
     * Description for the date header in each work order
     *
     * @param {}
     */

    function getDateDescription(workOrder) {
      if (workOrder.status === "open" || workOrder.status === "scheduled") {
        if (workOrder.is_overdue) {
          return "WAS DUE";
        } else {
          return "DUE";
        }
      } else if (workOrder.status === "completed") {
        return "COMPLETED";
      } else if (workOrder.status === "canceled") {
        return "CANCELED";
      }
    }
  }
})();
